import React, { useState, useEffect, useRef } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  PaginationItem,
  Button,
} from "@mui/material";
import { api, get } from "../../../../utils/api";
import { styled } from "@mui/material/styles";
import DateRangePickerComponent from "../../Roles and Permissions/Filters/Date";
import PaginationBox from "../../../../Components/Masters/Pagination";
import DeleteDialog from "../../../../Components/Masters/DeleteDialog";
import ColumnHeadings from "../../../../Components/Masters/ColumnHeadings";
import MenuActions from "../../../../Components/Masters/MenuActions";
import TableContent from "../../../../Components/Masters/TableContent";
import FilterDrawer from "../../../../Components/Masters/FilterDrawer";
import TopMenu from "../../../../Components/Masters/TopMenu";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import TableHeading from "../../../../Components/Masters/TableHeading";
import MenuIcon from "../../../../Components/Masters/MenuIcon";
import MultiSelect from "../../Roles and Permissions/Filters/MultiSelect";
import AddFranchise from "./AddFranchise";
import ViewFranchise from "./ViewFranchise";
import NoDataFound from "../../../../Components/Masters/NoDataFound";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import MastersSidebar from "../../../../Layout/MastersSidebar";
import Unauthorized from "../../../../Components/Unauthorized/Unauthorized";
import { useUser } from "../../../../context/AuthContext";
import {FacilityColumnHeading,
  facilityDataCellSx,
  getFacilityName,
  isFacilityHeading,
  shouldShowFacilityColumn,
  withFacilityHeading, FacilityDataCell, MasterDateDataCell } from "../../../../utils/facilityColumn";

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
  "&.Mui-selected": {
    backgroundColor: "green",
    color: "#fff",
    fontWeight: "bold",
  },
  "&:hover": {
    backgroundColor: "#ededed",
  },
}));

const formInputData = [
  {
    fieldName: "franchiseName",
    title: "Franchise Name",
    placeholder: "Enter franchise name",
  },
  {
    fieldName: "franchiseId",
    title: "Franchise ID",
    placeholder: "Enter franchise ID",
  },
  {
    fieldName: "country",
    title: "Country",
    placeholder: "Tap to select",
    type: "select",
  },
  {
    fieldName: "locationAddress",
    title: "Location/Address",
    placeholder: "Enter location/address",
  },
  {
    fieldName: "contactPerson",
    title: "Contact Person",
    placeholder: "Enter contact person",
  },
  {
    fieldName: "franchiseType",
    title: "Franchise Type",
    placeholder: "Tap to select",
  },
];

const viewInputData = [
  {
    fieldName: "franchiseName",
    title: "Franchise Name",
  },
  {
    fieldName: "franchiseId",
    title: "Franchise ID",
  },
  {
    fieldName: "country",
    title: "Country",
  },
  {
    fieldName: "locationAddress",
    title: "Location/Address",
  },
  {
    fieldName: "contactPerson",
    title: "Contact Person",
  },
  {
    fieldName: "franchiseType",
    title: "Franchise Type ",
  },
];

const Franchise = () => {
  const { user } = useUser();
  const showFacilityColumn = shouldShowFacilityColumn(user);
  const columnWidth = showFacilityColumn
    ? "11% 11% 18% 16% 18% 16% 8%"
    : "18% 22% 18% 20% 14% 8%";
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "createdAt",
    direction: "desc",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [addData, setAddData] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    Country: false,
    "Franchise Type": false,
  });
  const [viewData, setViewData] = useState(false);
  const [element, setElement] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [uniqueValues, setUniqueValues] = useState({});
  const [errors, setErrors] = useState({
    Date: false,
    Country: false,
    "Franchise Type": false,
  });
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    country: [],
    franchiseType: [],
  });
  const [tempFilter, setTempFilter] = useState({
    country: [],
    franchiseType: [],
    startDate: null,
    endDate: null,
  });

  const filters = ["Date", "Country", "Franchise Type"];

  const filtersToApply = {
    startDate: tempFilter?.startDate ? tempFilter?.startDate.format("YYYY-MM-DD") : "",
    endDate: tempFilter?.endDate ? tempFilter?.endDate.format("YYYY-MM-DD") : "",
    country: tempFilter?.country?.join(",") || "",
    franchiseType: tempFilter?.franchiseType?.join(",") || "",
  };

  const fetchUniqueValues = async () => {
    try {
      const response = await get(`/master/franchise/filter`);
      return {
        country: response?.data?.data?.country || [],
        franchiseType: response?.data?.data?.franchiseType || [],
      };
    } catch (error) {
      return {};
    }
  };

  const updatePage = () => {
    if (page > 1 && data.length === 1) {
      setPage(page - 1);
    }
    fetchData();
  };

  const fetchData = async (filtersArg = isFiltersApplied ? filtersToApply : {}) => {
    try {
      const queryParams = new URLSearchParams({
        page: String(page),
        limit: String(rowsPerPage),
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
        ...Object.fromEntries(
          Object.entries(filtersArg).filter(
            ([, v]) => v !== "" && v !== undefined && v !== null
          )
        ),
      }).toString();

      const response = await get(`/master/franchises?${queryParams}`);
      setData(response.data.data || []);
      setTotalPages(response.data.totalPages || 1);
      const uniqueVals = await fetchUniqueValues();
      setUniqueValues(uniqueVals);
    } catch (error) {
      console.error("Error fetching franchise master:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage, sortConfig]);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setElement(row);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    handleMenuClose();
    setAddData(true);
    setViewData(false);
  };

  const handleView = () => {
    handleMenuClose();
    setViewData(true);
    setAddData(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog(true);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleApplyFilters = () => {
    setPage(1);
    fetchData(filtersToApply);
    setStartDate(tempFilter?.startDate);
    setEndDate(tempFilter?.endDate);
    setSelectedFields({
      country: tempFilter?.country || [],
      franchiseType: tempFilter?.franchiseType || [],
    });
    setIsFiltersApplied(true);
    handleAppliedFilters();
    setDrawerFilterOpen(false);
  };

  const handleResetFilters = async () => {
    setTempFilter({
      startDate: null,
      endDate: null,
      country: [],
      franchiseType: [],
    });
    setStartDate(null);
    setEndDate(null);
    setSelectedFields({
      country: [],
      franchiseType: [],
    });
    setPage(1);
    await fetchData({});
    setErrors({});
    setAppliedFilters({});
    setIsFiltersApplied(false);
    setDrawerFilterOpen(false);
  };

  const handleAppliedFilters = () => {
    const isDateApplied = tempFilter?.startDate || tempFilter?.endDate ? true : false;
    const isCountryApplied = tempFilter?.country?.length > 0 ? true : false;
    const isTypeApplied = tempFilter?.franchiseType?.length > 0 ? true : false;

    setIsFiltersApplied(isDateApplied || isCountryApplied || isTypeApplied);

    setAppliedFilters((prev) => ({
      ...prev,
      Date: isDateApplied,
      Country: isCountryApplied,
      "Franchise Type": isTypeApplied,
    }));
  };

  const handleSort = (column, direction) => {
    setSortConfig({ key: column, direction });
  };

  const handleFilterDrawer = () => {
    setTempFilter({
      startDate: startDate,
      endDate: endDate,
      country: selectedFields.country,
      franchiseType: selectedFields.franchiseType,
    });
    setDrawerFilterOpen(false);
  };

  const columnHeadings = withFacilityHeading(
    [
      { fieldName: "createdAt", title: "Date" },
      { fieldName: "franchiseName", title: "Franchise Name" },
      { fieldName: "franchiseId", title: "Franchise ID" },
      { fieldName: "country", title: "Country" },
      { fieldName: "franchiseType", title: "Franchise Type" },
    ],
    showFacilityColumn
  );

  const renderSelectedFilter = () => {
    switch (selectedFilter) {
      case "Date":
        return (
          <DateRangePickerComponent
            startDate={tempFilter?.startDate}
            endDate={tempFilter?.endDate}
            setStartDate={(date) =>
              setTempFilter((prev) => ({ ...prev, startDate: date }))
            }
            setEndDate={(date) =>
              setTempFilter((prev) => ({ ...prev, endDate: date }))
            }
            setErrors={setErrors}
            errors={errors.Date}
          />
        );
      case "Country":
        return (
          <MultiSelect
            title="Country"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue = typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  country: newValue.country || newValue,
                };
              });
            }}
            errors={errors.Country}
            setErrors={setErrors}
            field="country"
            data={uniqueValues?.country}
          />
        );
      case "Franchise Type":
        return (
          <MultiSelect
            title="Franchise Type"
            selectedFields={tempFilter}
            setSelectedFields={(updater) => {
              setTempFilter((prev) => {
                const newValue = typeof updater === "function" ? updater(prev) : updater;
                return {
                  ...prev,
                  franchiseType: newValue.franchiseType || newValue,
                };
              });
            }}
            errors={errors["Franchise Type"]}
            setErrors={setErrors}
            field="franchiseType"
            data={uniqueValues?.franchiseType}
          />
        );
      default:
        return null;
    }
  };

  const tableContainerRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 1.5);
    }
  }, [data]);

  const getCellFieldData = (item, el) => {
    return item[el.fieldName];
  };

  const getDateFieldForColumn = (item, el) => {
    if (el.fieldName === "createdAt") return item.createdAt;
    return false;
  };

  return (
    <MainDashboardLayout sidebar={<MastersSidebar />}>
      <Unauthorized requiredModule="Setup | Master">
        <Box
          sx={{
            backgroundColor: "#ededed",
            width: "100%",
          }}
        >
          <MessagePopup {...{ snackOpen, setsnackOpen }} />
          <AddFranchise
            id={element ? element._id : ""}
            addData={addData}
            setAddData={setAddData}
            data={data}
            element={element}
            addUrl={"/master/franchises"}
            updateUrl={"/master/franchises"}
            fetchData={fetchData}
            setsnackOpen={setsnackOpen}
            formInputData={formInputData}
          />
          <ViewFranchise
            id={element ? element._id : ""}
            data={element}
            viewData={viewData}
            setViewData={setViewData}
            inputData={viewInputData}
            handleEdit={handleEdit}
          />
          {deleteDialog && (
            <DeleteDialog
              fetchData={updatePage}
              {...{
                deleteDialog,
                setDeleteDialog,
                id: element?._id,
                url: `${api}/master/franchises`,
                method: "delete",
                setsnackOpen,
              }}
            />
          )}
          {drawerFilterOpen && (
            <FilterDrawer
              {...{
                renderSelectedFilter,
                drawerFilterOpen,
                setDrawerFilterOpen,
                handleApplyFilters,
                handleFilterDrawer,
                setSelectedFilter,
                handleResetFilters,
                selectedFilter,
                filters,
                appliedFilters,
                selectedFields,
                setSelectedFields,
              }}
            />
          )}
          <TopMenu
            setData={setElement}
            setAddData={setAddData}
            {...{
              heading: "Scope 3",
              setDrawerFilterOpen,
              filterApplied: isFiltersApplied,
            }}
          />
          <TableContainer
            component={Paper}
            ref={tableContainerRef}
            sx={{ maxWidth: "100%" }}
          >
            <Box>
              <TableHeading heading={"Franchise Master"} />
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: columnWidth,
                  ...(showFacilityColumn && { alignItems: "stretch" }),
                  borderBottom: "1px solid #ddd",
                  borderTop: "1px solid #ddd",
                }}
              >
                {columnHeadings?.map((el) =>
                  isFacilityHeading(el) ? (
                    <FacilityColumnHeading
                      key={el.fieldName}
                      handleSort={handleSort}
                      sortConfig={sortConfig}
                    />
                  ) : (
                    <ColumnHeadings
                      key={el.fieldName}
                      {...{
                        title: el.title,
                        key: el.title,
                        handleSort,
                        field: el.fieldName,
                        sortConfig,
                      }}
                    />
                  )
                )}
                <Typography
                  sx={{
                    fontWeight: "bold",
                    padding: "8px 12px",
                    textAlign: "center",
                  }}
                >
                  Action
                </Typography>
              </Box>
              {data.length === 0 ? (
                <NoDataFound />
              ) : (
                data?.map((item) => (
                  <Box
                    key={item._id}
                    sx={{
                      display: "grid",
                      gridTemplateColumns: columnWidth,
                      ...(showFacilityColumn && { alignItems: "stretch" }),
                      borderBottom: "1px solid #ddd",
                    }}
                  >
                    {columnHeadings?.map((el) =>
                      isFacilityHeading(el) ? (
                        <FacilityDataCell key={el.fieldName}>
                          {getFacilityName(item) || "N/A"}
                        </FacilityDataCell>
                      ) : (
                        <TableContent
                          key={el.fieldName}
                          {...{
                            fieldData: getCellFieldData(item, el),
                            dateField: getDateFieldForColumn(item, el),
                          }}
                        />
                      )
                    )}
                    <MenuIcon {...{ handleMenuClick, field: item }} />
                  </Box>
                ))
              )}
            </Box>
          </TableContainer>
          {totalPages > 1 && (
            <PaginationBox
              isShortContent={isShortContent}
              {...{ totalPages, page, handleChangePage, StyledPaginationItem }}
            />
          )}
          <MenuActions
            {...{
              id: element?._id,
              handleView,
              handleEdit,
              handleDelete,
              anchorEl,
              handleMenuClose,
            }}
          />
        </Box>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Franchise;
